import { ReactNode } from 'react';
import { useOutletContext } from 'react-router-dom';

/** Contexto que o `RelatoriosLayout` entrega às rotas filhas no mobile (via `<Outlet context>`). */
export interface RelatoriosOutletContext {
  /** Cartão "Consulta atual" + painel de controle (BottomSheet) do informe ativo. */
  painelMobile?: ReactNode;
}

/**
 * Painel de controle mobile do informe, para a `RelatorioSecoesView` renderizá-lo abaixo do N2.
 * Tolera a ausência do contexto (desktop, ou a view montada fora do layout, como nos testes
 * isolados): devolve `null`.
 */
export default function usePainelMobile(): ReactNode {
  const contexto = useOutletContext<RelatoriosOutletContext | null | undefined>();
  return contexto?.painelMobile ?? null;
}
